<template lang='pug'>
  include /mixins
  loading-wrapper(:loading='loading')
    validation-observer(
      ref='observer'
      v-slot='{invalid}'
      tag='form'
      autocomplete='off'
    )
      validation(name='non field errors')
      card-panel(v-if='items.length')
        card-panel
          +b.scrollable-wrapper--till-2xl.--full
            +b.TABLE.table--variant_scroll.--space_lg(style='min-width: initial')
              +e.THEAD.thead
                +e.TR.row--relief
                  +e.TH.cell--variant_bold.--head 
                    row(alignment='center' space='md' nowrap)
                      cell
                        v-checkbox
                          +b.INPUT(type="checkbox"
                                  :value='allSelected'
                                  @input='allSelected = !allSelected;selectItems(allSelected)').control-checkbox__input
                      cell
                        v-caption(color='white'
                                  size='6') {{ _('t refund') }}
                  +e.TH.cell--variant_bold.--head 
                    v-caption(color='white') {{ _('t sector') }}
                  +e.TH.cell--variant_bold.--head 
                    v-caption(color='white') {{ _('t row') }}
                  +e.TH.cell--variant_bold.--head 
                    v-caption(color='white') {{ _('t seat') }}
              +e.TBODY.tbody
                +e.TR.row(v-for='ticket in items' :key='ticket.id')
                  +e.TD.cell--bordered_left_top.--bordered_left_bottom
                    row(alignment='center' space='md' nowrap)
                      cell
                        v-checkbox
                          +b.INPUT(type="checkbox"
                                  :value='ticket.id'
                                  v-model='selected').control-checkbox__input

                  +e.TD.cell 
                    v-caption(
                      size='6'
                      color='default'
                    ) {{ ticket.sector }}

                  +e.TD.cell 
                    v-caption(
                      size='6'
                      color='default'
                    ) {{ ticket.row }}

                  +e.TD.cell 
                    v-caption(
                      size='6'
                      color='default'
                    ) {{ ticket.seat }}
        card-panel
          row(justification='center')
            cell(cols='narrow')
              v-button(
                :variant='["clear", "block"]' 
                hover='danger'
                @click='refund'
                :disabled='!selected.length'
              )
                v-button-element
                  v-caption(
                    color='warning'
                    :variant='["uppercase", "bold"]'
                  ) {{ _('refund') }} {{ selected.length ? `${selected.length} tickets`: ''}}
      card-panel(v-else)
        notice
          template(v-slot:caption='')
            v-caption(variant='bold') {{ _('no ticket items in list')}}
                

</template>

<script>
import { 
  ref, watch, 
  
} from '@vue/composition-api'
import ShowService from '@cabinet/services/api/shows'
import { useResponse } from '@cabinet/composables/use-response'
import { useToggleSelect } from '@cabinet/composables/use-selected'

export default {
  props: {
    list: {
      type: Array
    },
    showId: {
      required: true
    }
  },
  setup(props, context) {
    
    const loading = ref(false)
    const allSelected = ref(false)
    const items = ref(props.list)
    const selected = ref([])

    const refund = async () => {
      loading.value = true
      try {
        await useResponse(ShowService.removeWithdraw({ id: props.showId, printed: selected.value}), context.root, context.refs.observer)
        loading.value = false
        context.emit('fetch')
        allSelected.value = false
        selected.value = []
      } catch (err) {
        loading.value = false
        console.error(err)
      }
    }
    watch(() => props.list, (val) => items.value = val) 
    const selectItems = value => {
      selected.value = useToggleSelect(items, value)
    }

    return {
      allSelected,
      selected,
      selectItems,
      refund,
      items,
      loading
    }
  }
}
</script>